// Internal Auditor — mirrors the admin sidebar but hides the sections/pages an
// auditor must not touch: Inbox, the entire CRM & Calls / Incentives / Operations
// sections, the Tele Sales / Order Form / Field Sales forms, and Settings.
// Attendance IS included (auditors need it). Everything left is read-heavy admin
// surface (dashboards, orders, attendance, finance, exports, reports, resources).
// Router guards in router/index.js are the matching source of truth — keep in sync.
export const INTERNAL_AUDITOR_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },
  { slug: 'link', name: 'Analytics', href: '/analytics', icon: 'cilChartPie' },
  { slug: 'link', name: 'Shipping Dashboard', href: '/shipping/dashboard', icon: 'cilRoute' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },

  { slug: 'title', name: 'Attendance' },
  {
    slug: 'dropdown',
    name: 'Attendance',
    icon: 'cilClock',
    elements: [
      { slug: 'link', name: 'Hours Report', href: '/attendance/hours', icon: 'cilCalendar' },
      { slug: 'link', name: 'Payroll Insights', href: '/attendance/monthly', icon: 'cilCash' },
      { slug: 'link', name: 'Coimbatore Branch', href: '/attendance/hours?device=a4:d5:c2:40:e8:2c', icon: 'cilBuilding' },
      { slug: 'link', name: 'Devices', href: '/attendance/devices', icon: 'cilDevices' },
      { slug: 'link', name: 'PIN → Staff Mapping', href: '/attendance/pins', icon: 'cilFingerprint' },
    ],
  },

  { slug: 'title', name: 'Finance & Exports' },
  {
    slug: 'dropdown',
    name: 'Payments',
    icon: 'cilDollar',
    elements: [
      { slug: 'link', name: 'COD Payments', href: '/pendingpayments', icon: 'cilHandCoin' },
      { slug: 'link', name: 'Razorpay Transactions', href: '/razorpay-transactions', icon: 'cilCreditCard' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Exports',
    icon: 'cilShareArrow',
    elements: [
      { slug: 'link', name: 'Tally Export', href: '/tallyexport', icon: 'cilSpreadsheet' },
      { slug: 'link', name: 'Zoho Export', href: '/zohoexport', icon: 'cilFile' },
      { slug: 'link', name: 'Verify Zoho Invoices', href: '/Verifyzohoinvoices', icon: 'cilCheckCircle' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
  { slug: 'link', name: 'Refunds', href: '/refund', icon: 'cilMoneyBack' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
